export const formatToMonth = (date: Date) =>
  DateFns.format(date, "MMM yyyy")
